<script setup>
/**
 * AutomationMock — one automation rule, as it reads in the product:
 * trigger → actions, with its execution history. Decorative.
 */
</script>

<template>
  <div class="space-y-3" aria-hidden="true">
    <div class="rounded-xl border border-slate-200 bg-white shadow-sm p-4">
      <div class="flex items-center justify-between mb-3">
        <span class="text-[13px] font-semibold text-slate-900">Confirmation d'inscription</span>
        <span class="inline-flex items-center gap-1.5 text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-2 py-0.5">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Active
        </span>
      </div>
      <div class="flex flex-wrap items-center gap-2 text-[12px]">
        <span class="font-mono text-[10px] uppercase tracking-wider text-slate-400">Si</span>
        <span class="rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-slate-700">Inscription soumise</span>
        <span class="text-slate-300">→</span>
        <span class="font-mono text-[10px] uppercase tracking-wider text-slate-400">Alors</span>
        <span class="rounded-md border border-primary-100 bg-primary-50 px-2 py-1 text-primary-700">Email + badge QR</span>
        <span class="rounded-md border border-primary-100 bg-primary-50 px-2 py-1 text-primary-700">Notification push</span>
      </div>
      <div class="mt-3 pt-3 border-t border-slate-100 text-[11px] text-slate-500 tabular-nums">
        1 284 exécutions · dernière il y a 2 min
      </div>
    </div>

    <div class="rounded-xl border border-slate-200 bg-white shadow-sm p-4 opacity-80">
      <div class="flex items-center justify-between mb-3">
        <span class="text-[13px] font-semibold text-slate-900">Relance activité</span>
        <span class="inline-flex items-center gap-1.5 text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-100 rounded-full px-2 py-0.5">
          <span class="w-1.5 h-1.5 rounded-full bg-emerald-500"></span> Active
        </span>
      </div>
      <div class="flex flex-wrap items-center gap-2 text-[12px]">
        <span class="font-mono text-[10px] uppercase tracking-wider text-slate-400">Si</span>
        <span class="rounded-md border border-slate-200 bg-slate-50 px-2 py-1 text-slate-700">Participation enregistrée</span>
        <span class="text-slate-300">→</span>
        <span class="font-mono text-[10px] uppercase tracking-wider text-slate-400">Alors</span>
        <span class="rounded-md border border-primary-100 bg-primary-50 px-2 py-1 text-primary-700">Push · tous les participants</span>
      </div>
      <div class="mt-3 pt-3 border-t border-slate-100 text-[11px] text-slate-500 tabular-nums">
        96 exécutions · dernière il y a 18 min
      </div>
    </div>
  </div>
</template>
